import { AuthResource } from "./resources/auth"
import { ContentResource } from "./resources/content"
import { DashboardResource } from "./resources/dashboard"
import { GlobalResource } from "./resources/global"
import { NotificationResource } from "./resources/notifications"
import { OrganizationResource } from "./resources/organization"
import { ProfileResource } from "./resources/profile"
import { SchoolResource } from "./resources/school"
import { TeachersResource } from "./resources/teachers"

export const API = {
  global: GlobalResource,
  auth: AuthResource,
  profile: ProfileResource,
  school: SchoolResource,
  notification: NotificationResource,
  content: ContentResource,
  teachers: TeachersResource,
  dashboard: DashboardResource,
  organization: OrganizationResource,
}
